import type { PokemonV2 } from '../types/pokemon';
import type { POKEMON_ITEM_ID } from '../types/item';
import itemData from '../data/item.json';

type Item = {
  id: number;
  name_ja: string;
};

const normalizeKey = (value: string) => value.normalize('NFKC');

const MEGA_POKEMON_TO_STONE_NAME_RAW: Array<[string, string]> = [
  ['メガフシギバナ', 'フシギバナイト'],
  ['メガリザードンX', 'リザードナイトX'],
  ['メガリザードンY', 'リザードナイトY'],
  ['メガカメックス', 'カメックスナイト'],
  ['メガスピアー', 'スピアナイト'],
  ['メガピジョット', 'ピジョットナイト'],
  ['メガライチュウX', 'ライチュウナイトX'],
  ['メガライチュウY', 'ライチュウナイトY'],
  ['メガピクシー', 'ピクシナイト'],
  ['メガフーディン', 'フーディナイト'],
  ['メガウツボット', 'ウツボットナイト'],
  ['メガヤドラン', 'ヤドランナイト'],
  ['メガゲンガー', 'ゲンガナイト'],
  ['メガガルーラ', 'ガルーラナイト'],
  ['メガスターミー', 'スターミナイト'],
  ['メガカイロス', 'カイロスナイト'],
  ['メガギャラドス', 'ギャラドスナイト'],
  ['メガプテラ', 'プテラナイト'],
  ['メガカイリュー', 'カイリュナイト'],
  ['メガミュウツーX', 'ミュウツナイトX'],
  ['メガミュウツーY', 'ミュウツナイトY'],
  ['メガメガニウム', 'メガニウムナイト'],
  ['メガオーダイル', 'オーダイルナイト'],
  ['メガデンリュウ', 'デンリュウナイト'],
  ['メガハガネール', 'ハガネールナイト'],
  ['メガハッサム', 'ハッサムナイト'],
  ['メガヘラクロス', 'ヘラクロスナイト'],
  ['メガエアームド', 'エアームドナイト'],
  ['メガヘルガー', 'ヘルガナイト'],
  ['メガバンギラス', 'バンギラスナイト'],
  ['メガジュカイン', 'ジュカインナイト'],
  ['メガバシャーモ', 'バシャーモナイト'],
  ['メガラグラージ', 'ラグラージナイト'],
  ['メガサーナイト', 'サーナイトナイト'],
  ['メガヤミラミ', 'ヤミラミナイト'],
  ['メガクチート', 'クチートナイト'],
  ['メガボスゴドラ', 'ボスゴドラナイト'],
  ['メガチャーレム', 'チャーレムナイト'],
  ['メガライボルト', 'ライボルトナイト'],
  ['メガサメハダー', 'サメハダナイト'],
  ['メガバクーダ', 'バクーダナイト'],
  ['メガチルタリス', 'チルタリスナイト'],
  ['メガジュペッタ', 'ジュペッタナイト'],
  ['メガチリーン', 'チリーンナイト'],
  ['メガアブソル', 'アブソルナイト'],
  ['メガアブソルZ', 'アブソルナイトZ'],
  ['メガオニゴーリ', 'オニゴーリナイト'],
  ['メガボーマンダ', 'ボーマンダナイト'],
  ['メガメタグロス', 'メタグロスナイト'],
  ['メガラティアス', 'ラティアスナイト'],
  ['メガラティオス', 'ラティオスナイト'],
  ['メガムクホーク', 'ムクホークナイト'],
  ['メガミミロップ', 'ミミロップナイト'],
  ['メガガブリアス', 'ガブリアスナイト'],
  ['メガルカリオ', 'ルカリオナイト'],
  ['メガルカリオZ', 'ルカリオナイトZ'],
  ['メガユキノオー', 'ユキノオナイト'],
  ['メガエルレイド', 'エルレイドナイト'],
  ['メガユキメノコ', 'ユキメノコナイト'],
  ['メガヒードラン', 'ヒードラナイト'],
  ['メガダークライ', 'ダークライナイト'],
  ['メガエンブオー', 'エンブオナイト'],
  ['メガドリュウズ', 'ドリュウズナイト'],
  ['メガタブンネ', 'タブンネナイト'],
  ['メガペンドラー', 'ペンドラナイト'],
  ['メガズルズキン', 'ズルズキナイト'],
  ['メガシビルドン', 'シビルドナイト'],
  ['メガシャンデラ', 'シャンデラナイト'],
  ['メガゴルーグ', 'ゴルーグナイト'],
  ['メガブリガロン', 'ブリガロナイト'],
  ['メガマフォクシー', 'マフォクシナイト'],
  ['メガゲッコウガ', 'ゲッコウガナイト'],
  ['メガカエンジシ', 'カエンジシナイト'],
  ['メガフラエッテ', 'フラエッテナイト'],
  ['メガニャオニクス', 'ニャオニクスナイト'],
  ['メガカラマネロ', 'カラマネナイト'],
  ['メガガメノデス', 'ガメノデスナイト'],
  ['メガドラミドロ', 'ドラミドナイト'],
  ['メガルチャブル', 'ルチャブルナイト'],
  ['メガジガルデ', 'ジガルデナイト'],
  ['メガディアンシー', 'ディアンシナイト'],
  ['メガケケンカニ', 'ケケンカニナイト'],
  ['メガグソクムシャ', 'グソクムシャナイト'],
  ['メガジジーロン', 'ジジーロナイト'],
  ['メガマギアナ', 'マギアナイト'],
  ['メガゼラオラ', 'ゼラオラナイト'],
  ['メガタイレーツ', 'タイレーツナイト'],
  ['メガスコヴィラン', 'スコヴィラナイト'],
  ['メガキラフロル', 'キラフロルナイト'],
  ['メガシャリタツ', 'シャリタツナイト'],
  ['メガセグレイブ', 'セグレイブナイト'],
];

const MEGA_POKEMON_TO_STONE_NAME = new Map<string, string>(
  MEGA_POKEMON_TO_STONE_NAME_RAW.map(([pokemonName, stoneName]) => [normalizeKey(pokemonName), normalizeKey(stoneName)]),
);

const itemList = itemData as Item[];

const itemNameToId = new Map<string, number>();
const itemNameToJa = new Map<string, string>();
itemList.forEach((item) => {
  const key = normalizeKey(item.name_ja);
  if (itemNameToId.has(key)) return;
  itemNameToId.set(key, item.id);
  itemNameToJa.set(key, item.name_ja);
});

const CUSTOM_MEGA_STONE_ID_BASE = 900_000_000;

const fnv1a32 = (text: string): number => {
  let hash = 0x811c9dc5;
  for (let i = 0; i < text.length; i += 1) {
    hash ^= text.charCodeAt(i);
    hash = Math.imul(hash, 0x01000193);
  }
  return hash >>> 0;
};

export type MegaStoneInfo = {
  megaPokemonName: string;
  stoneName: string;
  itemId: POKEMON_ITEM_ID;
};

const megaStoneNameByItemId = new Map<number, string>();
const megaStoneIdSet = new Set<number>();

const getMegaStoneInfoByStoneName = (stoneNameNormalized: string): { itemId: number; stoneNameJa: string } => {
  const existingItemId = itemNameToId.get(stoneNameNormalized);
  if (existingItemId != null) {
    return { itemId: existingItemId, stoneNameJa: itemNameToJa.get(stoneNameNormalized) ?? stoneNameNormalized };
  }
  const itemId = CUSTOM_MEGA_STONE_ID_BASE + fnv1a32(stoneNameNormalized);
  return { itemId, stoneNameJa: stoneNameNormalized };
};

MEGA_POKEMON_TO_STONE_NAME.forEach((stoneNameNormalized) => {
  const { itemId, stoneNameJa } = getMegaStoneInfoByStoneName(stoneNameNormalized);
  megaStoneNameByItemId.set(itemId, stoneNameJa);
  megaStoneIdSet.add(itemId);
});

const extractMegaNameKey = (pokemonNameJa: string): string | null => {
  const normalizedName = normalizeKey(pokemonNameJa);
  const match = normalizedName.match(/(?:\(|（)(メガ[^)）]+)(?:\)|）)/);
  const inner = match?.[1];
  if (inner && MEGA_POKEMON_TO_STONE_NAME.has(inner)) {
    return inner;
  }
  if (MEGA_POKEMON_TO_STONE_NAME.has(normalizedName)) {
    return normalizedName;
  }
  return null;
};

export const getMegaStoneForPokemon = (pokemon: PokemonV2): MegaStoneInfo | null => {
  const megaName = extractMegaNameKey(pokemon.name_ja);
  if (!megaName) return null;
  const stoneName = MEGA_POKEMON_TO_STONE_NAME.get(megaName);
  if (!stoneName) return null;
  const { itemId, stoneNameJa } = getMegaStoneInfoByStoneName(stoneName);
  return {
    megaPokemonName: megaName,
    stoneName: stoneNameJa,
    itemId,
  };
};

export const getMegaStoneItemIdForPokemon = (pokemon: PokemonV2): POKEMON_ITEM_ID | null => {
  return getMegaStoneForPokemon(pokemon)?.itemId ?? null;
};

export const isMegaStoneItemId = (itemId: number): boolean => megaStoneIdSet.has(itemId);

export const getMegaStoneNameByItemId = (itemId: number): string | undefined => megaStoneNameByItemId.get(itemId);
